<script setup lang="ts">
import { ProjectSortOrder } from '@/services/ide/projects.service'
import { ref } from 'vue'

// Props definition
const props = defineProps<{
  default?: ProjectSortOrder
  class?: string
}>()

// Emit definition
const emit = defineEmits(['onClick'])

// Ref to manage sort order
const sort = ref<ProjectSortOrder>(props.default || ProjectSortOrder.ASC)

/**
 * Toggles the sort order when the SVG is clicked
 */
const handleClick = () => {
  if (sort.value === ProjectSortOrder.ASC) {
    sort.value = ProjectSortOrder.DESC
  } else {
    sort.value = ProjectSortOrder.ASC
  }
  emit('onClick', sort.value)
}
</script>

<template>
  <div class="flex flex-col" @click="handleClick">
    <FontAwesomeIcon icon="fa-angle-up" class="h-2 w-2 cursor-pointer" />
    <FontAwesomeIcon icon="fa-angle-down" class="h-2 w-2 cursor-pointer" />
  </div>
</template>
